export default __webpack_public_path__ + "static/media/laputa.8baf76c4.jpg";